import React from "react";
import TagManager from "react-gtm-module";
import Basic from "../components/Basic";
import ListItem from "../components/DynamicDataListItem";
import Message from "../components/Message";
import { fetchData } from "../util/api";

const DynamicOffer = ({ ppcid, cid, showSavings }) => {
  const msg_ref = React.useRef(null);
  const [state, setState] = React.useState({
    loading: false,
    data: [],
  });

  React.useEffect(() => {
    const tagManagerArgs = {
      dataLayer: {
        ppc_lander: "Bankrate CD Table Events",
        lander_type: "Bankrate",
        product_name: "default",
        event: "comparisonTableLoad",
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  }, []);

  React.useEffect(() => {
    const handleFetchData = async () => {
      setState((state) => ({ ...state, loading: true }));

      const data = await fetchData( 90210);
        if (data.message === "success") {
          setState((state) => ({
            ...state,
            data: data.data.data.cd_rates,
            loading: false,
          }));
        } else {
          msg_ref.current.handleOpen();
          setState((state) => ({
            ...state,
            data: [],
            loading: false,
          }));
        }
    };
    handleFetchData();
  }, [state.zip_code]);

  let listContent;

  if (state.loading) {
    listContent = <div className="loader" />;
  } else {
    listContent = state.data.map((i, index) => {
      return (
        <ListItem
          min_to_open={i.min_to_open || 0}
          key={i.id}
          id={i.id}
          index={index + 1}
          name={i.institution.name}
          apy={i.apy}
          logo={i.institution.logo_url}
          advertiser_notes={i.advertiser_notes}
          term={i.product.name}
          phone={i.phone}
          link={`${i.ep_url}?clkid=${ppcid}_${cid}&utm_source=RateZip+API&pid=myfi_ratezip_api&utm_medium=partner`}
          rating={i.institution.reviews.cd_rating || i.institution.reviews.overall_rating}
          effective_at={i.effective_at}
          is_show_detail_btn={false}
          member={i.institution.insurance_information.type}
        />
      );
    });
  }

  return (
    <React.Fragment>
      <Message ref={msg_ref} message={"no data was found"} type={"warning"} />
      <Basic
        listContent={listContent}
        showSavings={showSavings}
      />
    </React.Fragment>
  );
};

export default DynamicOffer;
